/* eslint-disable no-restricted-imports */
import { keccak256, pack } from '@ethersproject/solidity';
import { FACTORY_ADDRESS_MAP, INIT_CODE_HASH } from '@uniswap/v2-sdk';
import { getCreate2Address } from 'ethers/lib/utils';
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctTimestamp, FctValue } from '../../../../Fct/generics';
import { getSupportedTokens } from '../../../../Fct/plugins/allowanceRequiredProtocols';
import { ROUTER_V2_ADDRESSES } from '../constants';
import { amountOutMinRisk } from './params';
export var RemoveLiquidity = createPlugin({
    protocol: 'UNISWAP',
    type: 'ACTION',
    method: 'removeLiquidity',
    description: 'Remove liquidity on Sushiswap',
    supportedContracts: ROUTER_V2_ADDRESSES,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'uniswap_router' }),
                methodParams: {
                    tokenA: new FctAddress({ destination: 'erc20', options: getSupportedTokens({ chainId: chainId }) }),
                    tokenB: new FctAddress({ destination: 'erc20', options: getSupportedTokens({ chainId: chainId }) }),
                    liquidity: new FctValue({ destination: 'wei_amount' }),
                    amountAMin: new FctValue({ destination: 'wei_amount', risk: amountOutMinRisk }),
                    amountBMin: new FctValue({ destination: 'wei_amount', risk: amountOutMinRisk }),
                    to: new FctAddress({}),
                    deadline: new FctTimestamp({}),
                },
            },
            output: {
                amountA: new FctValue({ destination: 'wei_amount', innerIndex: 0 }),
                amountB: new FctValue({ destination: 'wei_amount', innerIndex: 1 }),
            },
        });
    },
    initParams: {
        methodParams: {
            amountAMin: '0',
            amountBMin: '0',
            deadline: { type: 'global', id: 'blockTimestamp' },
        },
    },
    requiredApprovals: function (params, chainId) {
        var token0 = params === null || params === void 0 ? void 0 : params.methodParams.tokenA.value;
        var token1 = params === null || params === void 0 ? void 0 : params.methodParams.tokenB.value;
        var getToken = function () {
            if (token0 && typeof token0 === 'string' && token1 && typeof token1 === 'string') {
                var pairAddress = getCreate2Address(FACTORY_ADDRESS_MAP[chainId], keccak256(['bytes'], [pack(['address', 'address'], token0 < token1 ? [token0, token1] : [token1, token0])]), INIT_CODE_HASH);
                return pairAddress;
            }
            return undefined;
        };
        return [
            {
                to: getToken(),
                params: { spender: params === null || params === void 0 ? void 0 : params.to.value, amount: params === null || params === void 0 ? void 0 : params.methodParams.liquidity.value },
                method: 'approve',
                protocol: 'ERC20',
            },
        ];
    },
});
